var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "m-portlet" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "form",
      { staticClass: "m-form m-form--fit m-form--label-align-right" },
      [
        _c("div", { staticClass: "m-portlet__body" }, [
          _c(
            "div",
            { staticClass: "offer-template-overview" },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: Object.values(_vm.offerTemplates),
                    align: "top"
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "id",
                      label: "ID",
                      width: "70",
                      sortable: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "name", label: "Name", sortable: "" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "categoryName",
                      label: "Kategorie",
                      sortable: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "service_price",
                      label: "DL Preis",
                      sortable: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "image_per_hour",
                      label: "Bilder pro Stunde",
                      sortable: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "usedCount",
                      label: "Angebot benutzt",
                      sortable: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "projectCount",
                      label: "Projekt bekommen",
                      sortable: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "Aktionen" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary", size: "mini" },
                                on: {
                                  click: function($event) {
                                    return _vm.linkTo(scope.row.id)
                                  }
                                }
                              },
                              [_vm._v("Bearbeiten")]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-portlet__head" }, [
      _c("div", { staticClass: "m-portlet__head-caption" }, [
        _c("div", { staticClass: "m-portlet__head-title" }, [
          _c("h3", { staticClass: "m-portlet__head-text" }, [
            _vm._v("\n                Angebotsvorlage\n            ")
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "m-portlet__head-tools" }, [
        _c("ul", { staticClass: "m-portlet__nav" }, [
          _c("li", { staticClass: "m-portlet__nav-item" }, [
            _c(
              "a",
              {
                staticClass:
                  "m-portlet__nav-link m-portlet__nav-link--icon btn btn-brand",
                attrs: {
                  href: "/angebots-vorlagen/create",
                  title: "Neue Vorlage"
                }
              },
              [_c("i", { staticClass: "la la-plus" })]
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }